import AppService from 'App/legacy/AppService';
import { Feature, isAvailable } from 'App/services/FeatureHelperStandalone';

/** How many contacts one hand-picked add to a segment takes; past it, a filter in the segment is the way. */
export const SEGMENT_MAX_CONTACTS = 100;

/** ui-3's hasSegmentsAccess: /segments/add only lets admins and mail admins through. */
export const canAddToSegment = (): boolean => {
	const self = AppService.getSelf();
	return isAvailable(Feature.SEGMENT) && (!!self.administrator || !!self.userParams?.mailAdmin);
};
